import { format } from "date-fns";
import { useEffect } from "react";

import { DATE_FORMATS_FNS } from "components";
import { useTypedQuery } from "hooks";
import { useExactMonitoringFilters } from "modules/ExactMonitoring/components/ApiErrors/hooks/useExactMonitoringFilters";
import { ExactFailuresQueryKeys } from "modules/ExactMonitoring/queryKeys";
import { ApiInstance } from "utils/Api";

import type { ExactFailuresFilters } from "modules/ExactMonitoring/queryKeys";

const isValidStatusCode = (statusCode: number | null) => statusCode !== null && statusCode >= 100 && statusCode <= 599;

const generateExactFailuresPayload = (filters: ExactFailuresFilters) => ({
  ...filters,
  date_from: filters.date_from ? format(filters.date_from, DATE_FORMATS_FNS.ISOFormatStartOfDay) : null,
  date_to: filters.date_to ? format(filters.date_to, DATE_FORMATS_FNS.ISOFormatEndOfDay) : null,
  status_code: isValidStatusCode(filters.status_code) ? filters.status_code : null
});

export const useExactMonitoringQuery = () => {
  const filters = useExactMonitoringFilters();

  const query = useTypedQuery({
    queryKey: ExactFailuresQueryKeys.failures,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, generateExactFailuresPayload(filters), baseUrl)).data,
    enabled: false
  });

  useEffect(() => {
    if (filters.status_code && !isValidStatusCode(filters.status_code)) return;
    if (Boolean(filters.date_from) !== Boolean(filters.date_to)) return;

    query.refetch();
  }, [filters]);

  return query;
};
